export default __webpack_public_path__ + "static/media/README.1ba03d5b.md";